import $ from "jquery";
import moment from "moment";
import { Klass, u_ } from "@pressmedia/webappbase";
import vuwer from "@pressmedia/vuwer";
import "./klass.VuwDateField";

/**
 * VuwDatetimeField (extends VuwDateField)
 * - {Boolean} required
 * - {String} defaultTime: "HH:mm" (for PC)
 */
vuwer.appendKlass("VuwDatetimeField", {
	inpType: "datetime",
	inpClassList: ["inp", "inp-datetime"],
	
	_initialize: function _initialize(opt) {
		if( Klass("VuwDatetimeField").parent._initialize.call(this, opt) ) {
			var pk4Id;
			if(!this._html5Input) {
				pk4Id = this.paramKey.replace(/\[(\w*)\]/, "_$1").replace(/_$/, "");
				this.inpClassList.pop();
				
				// defaultTime
				u_.isString(this.defaultTime) && (function(arr) {
					if( arr.length !== 2 ||
							arr[0].length !== 2 || arr[1].length !== 2 ||
							isNaN( parseInt(arr[0]) ) || isNaN( parseInt(arr[1]) ) ) {
						this.defaultTime = false;
					}
				}).call( this, this.defaultTime.split(":") );
				!this.defaultTime && (this.defaultTime = "00:00");
				
				this
				.add("date", {
					vuwType: "dateField",
					paramKey: pk4Id + "_DD",
					idPrefix: this.idPrefix,
					required: this.required
				})
				.add("hour", {
					vuwType: "selectField",
					paramKey: pk4Id + "_hh",
					idPrefix: this.idPrefix,
					required: this.required,
					customizeSelect: true,
					emptyOptionText: "&nbsp;"
				}, function() {
					this.setNumberOptions(24);
				})
				.add("minute", {
					vuwType: "selectField",
					paramKey: pk4Id + "_mm",
					idPrefix: this.idPrefix,
					required: this.required,
					customizeSelect: true,
					emptyOptionText: "&nbsp;"
				}, function() {
					this.setNumberOptions(60);
				});
				
				// [バリデーション関数の上書き]
				this.validate = function() {
					var err_cnt = 0;
					this.getChildren().forEach(function(vuwField) {
						if( vuwField instanceof Klass("VuwField") ) {
							vuwField.validate() || err_cnt++;
						}
					});
					return !err_cnt;
				};
				
				// [required, disabled, readonly の動的な切り替え用]
				this._onChangeStateCallbacks.splice(-1, 0, function(state) {
					var methods = this.getChildren().map(function(vuwField) {
						if( vuwField instanceof Klass("VuwField") ) {
							return vuwField.setState(state);
						}
					});
					return $.when.apply($, methods);
				});
			}
			return this;
		} else {
			return false;
		}
	},
	
	getInpReady: function getInpReady($self) {
		if(this._html5Input) {
			Klass("VuwTextField").prototype.getInpReady.call(this, $self);
			
		} else {
			// DOMツリーに登録される前のことも考慮して、$self.findで取得する
			this.$inp = $self.find("#" + ["inp", this.idStr].join("_"));
			if(this.$inp.length) {
				this.$inp
				.on("input.monitor", function() {
					$(this).trigger("change", [false, "monitor"]);
				})
				.on("change.setVal", function(e, isTrigger) {
					!isTrigger && $.data(this, "vuwField").setVal(this.value, true);
				});
				
				$.data(this.$inp.get(0), "vuwField", this);
			}
			
			this.getChildren().forEach(function(vuwField) {
				( vuwField instanceof Klass("VuwField") ) && vuwField.renderField();
			});
			
			$self
			// 日時分が変更になったタイミングで自身のvalを更新する
			.on("change", ".vuw-field", function(e, isTrigger) {
				var vuw;
				if( (/vuw-field/).test(e.target.className) ) {
					return true;
				}
				
				vuw = $.data(e.delegateTarget, "vuw");
				!!vuw._updValTimer && clearTimeout(vuw._updValTimer);
				vuw._updValTimer = setTimeout(function() {
					var d, h, m, v;
					if(vuw._isClearingVal) {
						delete vuw._isClearingVal;
					} else {
						d = vuw.get("date").getVal();
						v = "";
						if(d) {
							h = vuw.get("hour").getVal();
							if( vuw.isNumber(h) ) {
								m = vuw.get("minute").getVal();
								if( vuw.isNumber(m) ) {
									h = ("0" + h).slice(-2);
									m = ("0" + m).slice(-2);
									v = d + "T" + h + ":" + m;
								}
							}
						}
						
						vuw.setVal(v, true, true);
					}
				}, 1);
			})
			// 日付変更時に時間が未指定の場合、defaultTimeの値を指定する
			.on("change", ".inp-date", function(e, isTrigger) {
				var vuw, def, hour, minute;
				if(!this.value || isTrigger) {
					return true;
				}
				
				vuw = $.data(e.delegateTarget, "vuw");
				def = vuw.defaultTime.split(":");
				def = {
					h: parseInt(def[0]).toString(),
					m: parseInt(def[1]).toString()
				};
				
				hour = vuw.get("hour");
				(hour.getVal() === undefined) && hour.setVal(def.h);
				minute = vuw.get("minute");
				(minute.getVal() === undefined) && minute.setVal(def.m);
			});
			
			this.clearVal();
		}
		return this;
	},
	
	setVal: function setVal(value, withoutChildren, antiTriggerChange) {
		var mVal;
		u_.isString(value) || (value = "");
		if(value) {
			mVal = moment(value);
			if( mVal.isValid() ) {
				value = mVal.format("YYYY-MM-DDTHH:mm");
			} else {
				value = "";
				mVal = undefined;
			}
		}
		
		Klass("VuwField").prototype.setVal.call(this, value);
		
		if( moment.isMoment(mVal) ) {
			if(!this._html5Input && !withoutChildren) {
				this.get("date").setVal(mVal.format("YYYY-MM-DD"), antiTriggerChange);
				this.get("hour").setVal(mVal.format("H"), antiTriggerChange);
				this.get("minute").setVal(mVal.format("m"), antiTriggerChange);
			}
		} else
		if(!this._html5Input && !withoutChildren) {
			this.get("date").setVal("", antiTriggerChange);
			this.get("hour").setVal("", antiTriggerChange);
			this.get("minute").setVal("", antiTriggerChange);
		}
		
		if(this.$inp.length) {
			this.$inp.val(value);
			
			!antiTriggerChange && this.$inp.trigger("change", [true]);
		}
		
		return this;
	},
	
	clearVal: function clearVal() {
		this._isClearingVal = true;
		return Klass("VuwDatetimeField").parent.clearVal.apply(this, arguments);
	},
	
	_getCopiedInp: function _getCopiedInp() {
		var arr, clones = Klass("VuwDatetimeField").parent._getCopiedInp.apply(this, arguments);
		if(clones.length) {
			arr = clones[0].text().split("T");
			clones[0].empty();
			(arr.length === 2) && clones[0].append(
				$("<span/>").addClass("day").text(arr[0]),
				$("<span/>").addClass("time-splitter"),
				$("<span/>").addClass("time").text(arr[1])
			);
		}
		return clones;
	},
	
	_renderField: function _renderField() {
		var
			attr = {
				type: this._html5Input ? "datetime-local" : "hidden",
				name: this.paramKey,
				id: ["inp", this.idStr].join("_")
			},
			elms = [];
		
		elms.push( $("<input/>").addClass( this.inpClassList.join(" ") ).attr(attr) );
		
		if(!this._html5Input) {
			elms.push( this.get("date").$self = $("<var/>") );
			elms.push( this.get("hour").$self = $("<var/>") );
			elms.push( $("<span/>").addClass("time-splitter") );
			elms.push( this.get("minute").$self = $("<var/>") );
		}
		
		return $.fn.append.apply(
			$("<fieldset/>").addClass("vuw-field field-datetime").attr({
				"id": ["field", this.idStr].join("_"),
				"data-name": this.paramKey
			}),
			elms
		);
	}
}, "VuwDateField");
